import React from 'react';

const Page404 = () => {
  return (
    <div className="Page404">
      Page not found :( <br />
      Maybe the page you are looking for has been removed, or you typed in the
      wrong URL
    </div>
  );
};

export default Page404;
